commons.filter('regionName', (REGIONS_LIST) => {
    return (regionId) => {
        const region = REGIONS_LIST.find(region => region.id === regionId);
        return region ? region.name : '';
    }
});